import React from "react";
import "./Footer.css"

// Icon components (you can replace these with your actual react-icons imports)
const MailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  </svg>
);

const WebsiteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand & Info Section */}
          <div className="footer-section footer-brand-section">
            <a href="/" className="footer-brand">
              <img src="/logo.png" alt="Conference Logo" className="footer-logo" />
              <span className="footer-brand-text">NCCIA</span>
            </a>
            <div className="footer-contact-info">
            <h3 className="footer-contact-title">National Conference on Computational Intelligence and Applications-2025 (NCCIA 2025)</h3>
              <div className="footer-contact-details">
                <a href="tel:+880 1729 885196" className="footer-contact-item">
                  <PhoneIcon />
                  <span>+880 1729 885196</span>
                </a>
                <a href="mailto:cse@just.edu.bd" className="footer-contact-item">
                  <MailIcon />
                  <span>cse@just.edu.bd</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/committee" className="footer-link">Committees</a></li>
              <li><a href="/dates" className="footer-link">Important Dates</a></li>
              <li><a href="/registration" className="footer-link">Registration</a></li>
              <li><a href="/schedules" className="footer-link">Program</a></li>
              <li><a href="/speakers" className="footer-link">Speakers</a></li>
            </ul>
          </div>

          {/* Submission & Services */}
          <div className="footer-section">
            <h3 className="footer-section-title">Submission</h3>
            <ul className="footer-links">
              <li><a href="/accepted-paper" className="footer-link">Accepted Abstract</a></li>
              <li><a href="/submission-guideline" className="footer-link">Submission Guidelines</a></li>
              <li><a href="https://drive.google.com/file/d/1tgdOzNNgK87WB7Ws7ZRv2lRs_JjPhWtJ/view" className="footer-link">Call for Papers</a></li>
            </ul>
          </div>

          {/* Venue & Info */}
          <div className="footer-section">
            <h3 className="footer-section-title">Venue & Info</h3>
            <ul className="footer-links">
              <li><a href="/venu-details" className="footer-link">Venue Details</a></li>
              <li><a href="/venue-accomodations" className="footer-link">Accommodations</a></li>
              <li><a href="/tourist-place" className="footer-link">Tourist Places</a></li>
              <li><a href="/contact" className="footer-link">Contact Us</a></li>
            </ul>
          </div>

          {/* Social & Connect */}
          <div className="footer-section">
            <h3 className="footer-section-title">Connect With Us</h3>
            <div className="footer-social">
              <a href="https://facebook.com" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
                <span>Facebook</span>
              </a>
              <a href="https://twitter.com" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <TwitterIcon />
                <span>Twitter</span>
              </a>
              <a href="https://nscia.just.edu.bd" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <WebsiteIcon />
                <span>Website</span>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-copyright">
            <p className="footer-copyright-text">
              © {currentYear} Department of Computer Science and Engineering, 
              Jashore University of Science and Technology. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="/privacy" className="footer-bottom-link" onClick={(e) => e.preventDefault()}>Privacy Policy</a>
              <a href="/terms" className="footer-bottom-link"   onClick={(e) => e.preventDefault()}>Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;